<template>
  <div>
    <md-card class="card-container">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <page-title :title="'使用者列表'"></page-title>
        </div>
      </div>
      <div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>使用者名稱</label>
              <md-input v-model="data.name"></md-input>
            </md-field>
          </div>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-button class="md-raised md-danger" @click="clearAll">清除搜尋結果</md-button>
          <md-button class="md-raised md-primary" @click="$router.push('/user/add')">新增使用者</md-button>
        </div>
        <div class="md-layout-item">
          <md-button class="float-right md-raised md-primary" @click="getUsers()">搜尋</md-button>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-table>
            <md-table-row>
              <md-table-head>帳號</md-table-head>
              <md-table-head>名稱</md-table-head>
              <md-table-head>角色</md-table-head>
            </md-table-row>
            <md-table-row v-for="(user, index) in users" :users="users" :key="user.id">
              <md-table-cell>
                <router-link :to="`/user/${user.id}`">
                  {{user.username}}
                </router-link>
              </md-table-cell>
              <md-table-cell>{{user.name}}</md-table-cell>
              <md-table-cell>{{user.role.name}}</md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <paginate
            :page-count="Math.ceil(pageCount / 20)"
            :click-handler="getUsers"
            :prev-text="'前頁'"
            :next-text="'下頁'"
            :container-class="'pagination'"
            :no-li-surround="true"
          >
          </paginate>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>
import PageTitle from '@/components/Shared/PageTitle'
import axios from 'axios'
import urls from '@/urls'
import Paginate from 'vuejs-paginate'

export default {
  data () {
    return {
      pageCount: 0,
      data: {
        name: null
      },
      users: []
    }
  },
  components: {
    PageTitle, Paginate
  },
  created () {
    this.getUsers()
  },
  methods: {
    clearAll: async function () {
      this.users = []
    },
    getUsers: async function (page = 1) {
      for (var i in this.data) {
        if (this.data[i] === '') {
          this.data[i] = null
        }
      }
      let req = await axios.get(urls({route: 'user'}), {params: {...this.data, page}})
      this.users = req.data.data
      this.pageCount = req.data.count
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/User/UserList.vue